import {Component, OnInit} from '@angular/core';
import {MatInput} from "@angular/material/input";
import {
  MatCard,
  MatCardContent
} from "@angular/material/card";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ApiService} from "../api.service";
import {Router, RouterLink} from "@angular/router";

@Component({
  selector: 'app-login',
  imports: [
    MatInput,
    MatCard,
    MatButton,
    MatCardContent,
    MatFormField,
    MatIcon,
    MatLabel,
    FormsModule,
    MatProgressSpinner,
    ReactiveFormsModule,
    RouterLink,
    MatIconButton
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})

export class LoginComponent implements OnInit{
  public email: any;
  public disableInputs: boolean = false;
  public loading: boolean = false;
  public errorMsg: string = '';
  public siteLoading: boolean = false;

  emailForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    submit: new FormControl()
  });

  constructor(public api: ApiService, public router: Router) {
  }

  async ngOnInit() {
    this.siteLoading = true;
    await this.api.getAuthCookie();
    this.siteLoading = false;
    if (this.api.isLogged && this.api.isAdmin) this.router.navigate(['admin/users']);
    else if (this.api.isLogged) this.router.navigate(['dashboard']);
  }

  async sendMail() {
    this.email = this.emailForm.get('email')?.value;
    this.emailForm.get('email')?.disable();
    this.emailForm.get('submit')?.disable();
    this.disableInputs = true;
    this.loading = true;
    const error = await this.api.login(this.email);
    this.loading = false;
    if (error) {
      this.errorMsg = error;
      setTimeout(() => {
        this.emailForm.get('email')?.enable();
        this.emailForm.get('submit')?.enable();
        this.disableInputs = false;
      }, 1000);
    }
    else this.errorMsg = '';
  }
  ngAfterContentInit() {
    if (!this.api.isLogged)
      (document.querySelector('body') as HTMLElement).style.backgroundImage = 'linear-gradient(35deg, #fe3620 0%, #ff7c00 30%, #ff7c00 70%, #fe3620 90%)';
  }
  ngOnDestroy() {
    (document.querySelector('body') as HTMLElement).style.backgroundImage = 'unset';
  }

}
